module.exports = __webpack_public_path__ + "img/not.7328996c.svg";